import React from 'react';
import MarkerGauge from '@splunk/dashboard-visualizations/MarkerGauge';

export default () => (
    <MarkerGauge
        options={{
            ranges: [
                {
                    from: -10,
                    to: 0,
                    value: '#ff7152',
                },
                {
                    from: 0,
                    to: 20,
                    value: '#ff9800',
                },
                {
                    from: 20,
                    to: 30,
                    value: '#cddc39',
                },
                {
                    from: 30,
                    to: 40,
                    value: '#00bcd4',
                },
            ],
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'count' }],
                    columns: [['35']],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
